import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN */}
      <main className="flex-1">
        <section className="container mx-auto max-w-5xl px-4 py-12">

          {/* CARD */}
          <div className="rounded-2xl border border-border bg-card p-6 md:p-10 shadow-sm">

            {/* HEADER */}
            <div className="mb-10">
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground">
                Privacy <span className="text-primary">Policy</span>
              </h1>

              <p className="mt-4 text-muted-foreground">
                Last Updated: May 2026
              </p>
            </div>

            {/* INTRO */}
            <div className="space-y-6 text-muted-foreground leading-7">

              <p>
                DealSwapify values your privacy and is committed to protecting
                your personal information. This Privacy Policy explains how we
                collect, use, and safeguard your information when you use our
                platform.
              </p>

              {/* INFORMATION WE COLLECT */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Information We Collect
                </h2>

                <ul className="list-disc pl-6 space-y-2">
                  <li>Name and account details</li>
                  <li>Email address and contact information</li>
                  <li>Profile pictures and uploaded item images</li>
                  <li>Messages exchanged through marketplace chat but not stored</li>
                  <li>Device and browser information</li>
                  <li>Notification tokens for push notifications</li>
                </ul>
              </div>

              {/* HOW WE USE */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  How We Use Your Information
                </h2>

                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide marketplace functionality</li>
                  <li>Enable real-time messaging</li>
                  <li>Send notifications and updates</li>
                  <li>Improve user experience and security</li>
                  <li>Prevent fraud and misuse of the platform</li>
                </ul>
              </div>

              {/* USER CONTENT */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  User Content
                </h2>

                <p>
                  Items, images, descriptions, and profile information posted
                  on DealSwapify may be visible to other users of the platform.
                  Users are responsible for the information they choose to
                  share publicly.
                </p>
              </div>

              {/* NOTIFICATIONS */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Notifications
                </h2>

                <p>
                  DealSwapify may send push notifications related to chats,
                  listings, marketplace activity, and account updates. You may
                  disable notifications through your browser or device settings.
                </p>
              </div>

              {/* DATA SECURITY */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Data Security
                </h2>

                <p>
                  We implement reasonable security measures to protect user
                  data. However, no online platform can guarantee absolute
                  security.
                </p>
              </div>

              {/* THIRD PARTY */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Third-Party Services
                </h2>

                <p>
                  DealSwapify may use third-party services such as cloud
                  storage, notifications, analytics, and hosting providers to
                  operate the platform.
                </p>
              </div>

              {/* USER RIGHTS */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Your Rights
                </h2>

                <p>
                  Users may update or remove certain account information through
                  their profile settings. You may also stop using the platform
                  at any time.
                </p>
              </div>

              {/* POLICY CHANGES */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Changes to This Policy
                </h2>

                <p>
                  DealSwapify may update this Privacy Policy from time to time.
                  Continued use of the platform after changes means you accept
                  the updated policy.
                </p>
              </div>

              {/* CONTACT */}
              <div>
                <h2 className="text-2xl font-semibold text-foreground mb-3">
                  Contact Us
                </h2>

                <p>
                  If you have questions regarding this Privacy Policy, please
                  contact the DealSwapify support team.
                </p>
              </div>

            </div>

          </div>

        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;